import request from '@/utils/http';

// 计费异常处理分页查询
export const queryByPage = (data) => {
    return request({
        url: `/api-tms/billing/exception/queryByPage`,
        method: 'post',
        data
    });
};

// 批量删除
export const batchDelete = (data) => {
    return request({
        url: `/api-tms/billing/exception/delete`,
        method: 'post',
        data
    });
};

// 试算
export const handleRecalculate = (data) => {
    return request({
        url: `/api-tms/insettlement/try`,
        method: 'post',
        data
    });
};
